import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getWalletBalanceApi } from '../../api/wallet.api';
import { logout } from './authSlice';

export const fetchWalletBalance = createAsyncThunk(
  'wallet/fetchBalance',
  async ({ silent = false } = {}, { rejectWithValue }) => {
    try {
      const result = await getWalletBalanceApi();
      return { balance: result.balance, silent };
    } catch (error) {
      if (silent) {
        console.warn(error?.message || 'Wallet balance refresh failed.');
      }

      return rejectWithValue({
        message: error?.message || 'Wallet balance request failed.',
        silent
      });
    }
  }
);

const walletSlice = createSlice({
  name: 'wallet',
  initialState: {
    balance: null,
    loading: false,
    refreshing: false,
    error: null
  },
  reducers: {
    clearWalletBalance: (state) => {
      state.balance = null;
      state.loading = false;
      state.refreshing = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWalletBalance.pending, (state, action) => {
        const silent = action.meta.arg?.silent ?? false;

        if (silent) {
          state.refreshing = true;
        } else {
          state.loading = true;
        }

        state.error = null;
      })
      .addCase(fetchWalletBalance.fulfilled, (state, action) => {
        state.balance = action.payload.balance;
        state.loading = false;
        state.refreshing = false;
        state.error = null;
      })
      .addCase(fetchWalletBalance.rejected, (state, action) => {
        const silent = action.meta.arg?.silent ?? false;

        state.loading = false;
        state.refreshing = false;

        if (!silent) {
          state.error = action.payload?.message || action.error?.message || 'Wallet balance request failed.';
        }
      })
      .addCase(logout, (state) => {
        state.balance = null;
        state.loading = false;
        state.refreshing = false;
        state.error = null;
      });
  }
});

export const { clearWalletBalance } = walletSlice.actions;
export default walletSlice.reducer;
